
import { Toaster } from "@/components/ui/sonner";
import { TooltipProvider } from "@/components/ui/tooltip";
import { QueryClient, QueryClientProvider } from "@tanstack/react-query";
import { BrowserRouter } from "react-router-dom";
import { UserProvider } from "@/contexts/UserContext";
import { CookieConsentProvider } from "@/contexts/CookieConsentContext";
import { ModalProvider } from "@/contexts/ModalProvider";
import { ShoppingModeProvider } from "@/contexts/ShoppingModeContext";
import ScrollToTop from "./components/ScrollToTop";
import AppContent from "./components/AppContent";

// Configure QueryClient with optimized settings
const queryClient = new QueryClient({
  defaultOptions: {
    queries: {
      refetchOnWindowFocus: true,
      refetchOnReconnect: true,
      staleTime: 2 * 60 * 1000, // 2 minutes default
      gcTime: 24 * 60 * 60 * 1000, // 24 hours
    },
  },
});

function App() {
  return (
    <QueryClientProvider client={queryClient}>
      <CookieConsentProvider>
        <UserProvider>
          <ModalProvider>
            <ShoppingModeProvider>
              <TooltipProvider>
                <Toaster />
                <BrowserRouter>
                  <ScrollToTop />
                  <AppContent />
                </BrowserRouter>
              </TooltipProvider>
            </ShoppingModeProvider>
          </ModalProvider>
        </UserProvider>
      </CookieConsentProvider>
    </QueryClientProvider>
  );
}

export default App;
